import type { Locale } from './types';

export const site = {
  name: 'Maxim Domentii',
  domain: 'maximdomentii.com',
  baseUrl: 'https://maximdomentii.com',
  email: 'maxim.domentii92@gmail.com',
  phoneDisplay: '+41 77 951 03 15',
  phoneSchema: '+41779510315',
  addressStreet: 'In der Frohburg 16',
  addressPostalCode: '8172',
  addressLocality: 'Niederglatt',
  addressCountryEn: 'Switzerland',
  addressCountryDe: 'Schweiz',
  uid: 'CHE-236.087.459',
  vat: 'CHE-236.087.459 MWST',
  linkedin: 'https://www.linkedin.com/in/maxim-domentii-4400377a/',
  linkedinRecommendations:
    'https://www.linkedin.com/in/maxim-domentii-4400377a/details/recommendations',
  contactEndpoint: 'https://q2lg02zqic.execute-api.eu-central-1.amazonaws.com/v1/contact-us',
} as const;

export const locales = ['en', 'de'] as const;

export const localeNames: Record<Locale, string> = {
  en: 'English',
  de: 'Deutsch',
};

export const localeLabels: Record<Locale, string> = {
  en: 'EN',
  de: 'DE',
};

export const localStorageLocaleKey = 'maximdomentii.locale';

export const productionLastUpdated = '2026-04-30';
